module.exports = __webpack_public_path__ + "static/media/note7.f7bcc5a0.wav";